import React from "react";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaArrowRight } from "react-icons/fa"; // Icons install karein: npm install react-icons

import Navr from "../Navbar/Navr";
import Footer from "../Components2/Footer";

// Images Import
import heroImg from "../Ecomphotos/rajasthan.jpg"; // Main Hero Image
import ud from "../Ecomphotos/udaipur.jpg";
import jal from "../Ecomphotos/jaiselmer.jpg";
import ku from "../Ecomphotos/jodhpur.jpg";
import jar from "../Ecomphotos/jaipur.jpg";

export default function Rajasthan() {
  // Data array for cities (Clean Code)
  const cities = [
    { id: 1, name: "Udaipur", img: ud, desc: "The City of Lakes" },
    { id: 2, name: "Jaisalmer", img: jal, desc: "The Golden City" },
    { id: 3, name: "Jodhpur", img: ku, desc: "The Blue City" },
    { id: 4, name: "Jaipur", img: jar, desc: "The Pink City" },
  ];

  return (
    <>
      <Navr />

      {/* --- Section 1: Hero Banner (Parallax) --- */}
      <div
        className="hero-section d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay-dark"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h5 className="text-warning text-uppercase letter-spacing-3 mb-3">
              Welcome to the Land of Kings
            </h5>
            <h1 className="display-3 fw-bold text-white mb-4">
              Royal Rajasthan Tour
            </h1>
            <p
              className="text-light lead mx-auto"
              style={{ maxWidth: "700px" }}
            >
              Experience the grandeur of royal palaces, ancient forts, and
              colorful desert landscapes.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Introduction (Text + Image) --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="align-items-center">
            <Col lg={7} className="mb-4 mb-lg-0">
              <h4 className="text-danger text-uppercase fw-bold mb-2">
                Discover Heritage
              </h4>
              <h2 className="mb-4 fw-bold text-dark">
                Best Tour Packages from Jodhpur
              </h2>
              <p className="text-muted text-justify lead-sm">
                Explore the vibrant soul of Rajasthan with our exclusive tour
                package. From the golden sands of Jaisalmer to the pink charm of
                Jaipur and the blue hues of Jodhpur, every city tells a majestic
                story. Witness folk music, dance, camel safaris, and traditional
                Rajasthani hospitality that bring the culture to life.
              </p>
              <p className="text-muted text-justify lead-sm">
                Our Rajasthan tour includes comfortable stays, guided
                sightseeing, and memorable cultural experiences. Discover the
                true essence of India’s royal heritage and create timeless
                memories in the Land of Kings.
              </p>
              <Link
                to="/contact"
                className="btn btn-danger px-4 py-2 mt-3 rounded-pill shadow-sm"
              >
                Book Your Experience <FaArrowRight className="ms-2" />
              </Link>
            </Col>
            <Col lg={5}>
              <div className="image-frame">
                <img
                  src={heroImg}
                  alt="Rajasthan Culture"
                  className="img-fluid rounded shadow-lg"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Cities Grid (Cards) --- */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h6 className="text-danger fw-bold text-uppercase">Destinations</h6>
            <h2 className="fw-bold">Explore Vibrant Cities</h2>
            <div className="title-line mx-auto"></div>
          </div>

          <Row className="g-4">
            {cities.map((city) => (
              <Col md={6} lg={3} key={city.id}>
                <div className="city-card">
                  <div className="city-img-wrapper">
                    <img src={city.img} alt={city.name} />
                    <div className="city-overlay">
                      <h4 className="text-white fw-bold">{city.name}</h4>
                      <p className="text-light small mb-0">{city.desc}</p>
                    </div>
                  </div>
                  <div className="city-details p-3 text-center">
                    <span className="text-muted">
                      <FaMapMarkerAlt className="text-danger me-1" /> Rajasthan
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- Section 4: Call to Action --- */}
      <section className="cta-strip py-5 text-center text-white">
        <Container>
          <h2 className="fw-bold mb-3">Ready to plan your Royal Trip?</h2>
          <p className="mb-4 opacity-75">
            Customize your itinerary with Jawali Holidays today.
          </p>
          <Link
            to="/Contact"
            className="btn btn-light text-danger fw-bold px-5 py-3 rounded-pill shadow"
          >
            Plan Your Trip Now
          </Link>
        </Container>
      </section>

      <Footer />
    </>
  );
}
